var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
var Meta = /** @class */ (function (_super) {
    __extends(Meta, _super);
    function Meta() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Meta.prototype.setMetaTitles = function (title, setPageTitle) {
        if (setPageTitle === void 0) { setPageTitle = true; }
        if (setPageTitle) {
            document.title = title;
        }
        this.getMetaByName('title').setAttribute('content', title);
        this.getMetaByProperty('og:title').setAttribute('content', title);
    };
    Meta.prototype.setMetaDescriptions = function (description) {
        this.getMetaByName('description').setAttribute('content', description);
        this.getMetaByProperty('og:description').setAttribute('content', description);
    };
    Meta.prototype.setMetaKeywords = function (keywords) {
        if (Array.isArray(keywords)) {
            keywords = keywords.join(',');
        }
        this.getMetaByName('keywords').setAttribute('content', keywords);
    };
    Meta.prototype.setMetaImage = function (image) {
        this.getMetaByProperty('og:image').setAttribute('content', image);
    };
    Meta.prototype.setTwitterCard = function (withImage) {
        if (withImage) {
            this.getMetaByName('twitter:card').setAttribute('content', 'summary_large_image');
        }
        else {
            this.getMetaByName('twitter:card').setAttribute('content', 'summary');
        }
    };
    Meta.prototype.getOrSetMeta = function (attribute, value) {
        var element = document.querySelector("meta[" + attribute + "=\"" + value + "\"]");
        if (!element) {
            element = document.createElement('meta');
            element.setAttribute(attribute, value);
            document.getElementsByTagName('head')[0].appendChild(element);
        }
        return element;
    };
    Meta.prototype.getMetaByName = function (name) {
        return this.getOrSetMeta('name', name);
    };
    Meta.prototype.getMetaByProperty = function (property) {
        return this.getOrSetMeta('property', property);
    };
    Meta.prototype.setCanonicalLink = function (link) {
        var element = document.querySelector('link[rel="canonical"]');
        if (!element) {
            element = document.createElement('link');
            element.setAttribute('rel', 'canonical');
            document.head.appendChild(element);
        }
        element.setAttribute('href', link);
    };
    Meta.prototype.unsetCanonicalLink = function () {
        var element = document.querySelector('link[rel="canonical"]');
        element === null || element === void 0 ? void 0 : element.remove();
    };
    Meta.prototype.resetMeta = function () {
        this.setMetaTitles('');
        this.setMetaDescriptions('');
        this.setMetaKeywords('');
        this.setMetaImage('');
    };
    Meta = __decorate([
        Component
    ], Meta);
    return Meta;
}(Vue));
export default Meta;
